<template>
  <div>
    <!-- 添加开票信息弹窗 -->
    <el-dialog
        :close-on-press-escape="false" :close-on-click-modal="false"
        :modal-append-to-body="false"
        top="25vh"
        :visible.sync="invoicingeAddDialog"
        width="900px"
        title="添加开票信息"
        :before-close="invoicingeAddClose"
    >
      <div class="add-box">
        <el-form
            ref="invoicingFromRules"
            :model="invoicingFrom"
            :rules="invoicingFromRules"
            label-width="120px"
        >
          <el-form-item label="发票抬头" prop="title">
            <el-input
                v-model="invoicingFrom.title"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="税号" prop="tax_number">
            <el-input
                v-model="invoicingFrom.tax_number"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="地址" prop="address">
            <el-input
                v-model="invoicingFrom.address"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input
                v-model="invoicingFrom.phone"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行" prop="bank">
            <el-input
                v-model="invoicingFrom.bank"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="账号" prop="account">
            <el-input
                v-model="invoicingFrom.account"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="接收邮箱" prop="email">
            <el-input
                v-model="invoicingFrom.email"
                placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="flex-end">
          <el-button @click="invoicingeAddClose">取 消</el-button>
          <el-button type="primary" @click="addInvoicing">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {invoiceAdd, invoiceUpdate, invoiceDetail} from "@/api/modules/user";

export default {
  name: "addInvoicing",
  props: {
    invoicingeAddDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      // 用户发票表单
      invoicingFrom: {
        title: '',
        tax_number: "",
        address: "",
        phone: "",
        bank: "",
        account: "",
        email: "",
      },
      // 用户发票表单校验
      invoicingFromRules: {
        title: [{required: true, message: "请输入发票抬头", trigger: "blur"}],
        tax_number: [
          {required: true, message: "请输入税号", trigger: "blur"},
        ],
        phone: [
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  watch: {
    invoicingeAddDialog: {
      handler(newVal) {
        if (newVal) {
          this.invoicingFrom.title = this.userInfo.company
        }
      },
      immediate: true,
      deep: true,
    },
    id: {
      handler(newVal) {
        if (newVal) {
          this.editInvoicing();
        } else {
          this.invoicingFrom.id = "";
          this.invoicingFrom = {
            title: '',
            tax_number: "",
            address: "",
            phone: "",
            bank: "",
            account: "",
            email: "",
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  // mounted() {
  //   if (this.userInfo.company) {
  //     this.invoicingFrom.title = this.userInfo.company
  //   }
  // },
  methods: {
    editInvoicing() {
      invoiceDetail(this.id).then((res) => {
        this.invoicingFrom = res.data.data;
        this.$emit("close", true);
      });
    },
    // 校验开票信息
    addInvoicing() {
      this.$refs["invoicingFromRules"].validate((valid) => {
        if (valid) {
          this.submitInvoicing();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 提交开票信息
    async submitInvoicing() {
      let res;
      if (this.invoicingFrom.id) {
        res = await invoiceUpdate(this.invoicingFrom.id, this.invoicingFrom);
      } else {
        delete this.invoicingFrom.id;
        res = await invoiceAdd(this.invoicingFrom);
      }
      if (res.data.code == 10000) {
        this.$message.success({
          message: res.data.message,
          duration: 2000,
          offset: 200,
        });
      } else {
        this.$message.error({
          message: res.data.message,
          duration: 2000,
          offset: 200,
        });
      }
      this.$refs["invoicingFromRules"].resetFields();
      this.invoicingeAddClose();
      this.$emit("success");
    },
    invoicingeAddClose() {
      this.$emit("close", false);
    },
  },
};
</script>
<style scoped lang="scss"></style>
